let isLastNavCustom = false;
const customNav = document.querySelector('.header__navigation.custom-nav');
const mainMenuDetails = [
    ...document.querySelectorAll('header > .header__navigation details')
];

const megaMenuDetails = [
    ...document.querySelectorAll('#plg-custom-mega-menu details')
];

const toggleMainMenuPointerEvents = (pe) => {
    mainMenuDetails.forEach(e => e.style.pointerEvents = pe);
};

const toggleMegaMenuPointerEvents = (pe) => {
    megaMenuDetails.forEach(e => e.style.pointerEvents = pe);
};


/**
 * @param {MutationRecord} mutation
 */
const handleMegaZIndex = (mutation) => {
    /**
     * @type {HTMLElement}
     */
    const el = mutation.target;
    if (mutation.type === 'attributes' && el.tagName.toLowerCase() === 'details') {
        const parentNav = mutation.target.parentElement.closest('.header__navigation');

        if (!parentNav) return;

        if (
            document.querySelectorAll(
                'header > .header__navigation details[open]'
            ).length > 0
        ) return;

        if (el.getAttribute('open') !== null) {
            parentNav.style.zIndex = '99';
            toggleMainMenuPointerEvents('none');
        } else {
            if (
                document.querySelectorAll(
                    '#plg-custom-mega-menu details[open]'
                ).length > 0
            ) {
                return;
            }
            parentNav.style.zIndex = 'initial';
            toggleMainMenuPointerEvents('all');
        }
    }
};

/**
 * @param {MutationRecord} mutation
 */
const handleMainMenu = (mutation) => {
    /**
     * @type {HTMLElement}
     */
    const el = mutation.target;
    if (mutation.type === 'attributes' && el.tagName.toLowerCase() === 'details') {
        if (
            document.querySelectorAll(
                'header > .header__navigation details[open]'
            ).length > 0
        ) {
            toggleMegaMenuPointerEvents('none');
            return;
        }

        if (el.getAttribute('open') !== null) {
            toggleMegaMenuPointerEvents('none');
        } else {
            toggleMegaMenuPointerEvents('all');
        }
    }
};


const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        handleMegaZIndex(mutation);
    });
});


const observerMainMenu = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        handleMainMenu(mutation);
    });
});
// , header > .header__navigation details
[
    ...document.querySelectorAll('#plg-custom-mega-menu details')
].forEach((el) => {
    observer.observe(el, {
        attributes: true
    });
});
[
    ...document.querySelectorAll('header > .header__navigation details')
].forEach((el) => {
    observerMainMenu.observe(el, {
        attributes: true
    });
});

document.querySelectorAll('#plg-custom-mega-menu .mega-menu')
    .forEach((el) => {
        el.style.paddingTop = `${document.getElementById('plg-custom-mega-menu').getBoundingClientRect().height / 2}px`;
    });


[
    ...document.querySelectorAll('#plg-custom-mega-menu .menu-drawer-button')
].forEach(
    (button, i) => {
        button.addEventListener('click', (e) => {
            [
                ...document.querySelectorAll('#Custom-drawer .drawer__menu > li')
            ][i].querySelector('summary').click();
        });
    }
);


if (window.innerWidth >= 768) {
    console.log('open details');
    [...document.querySelectorAll('.footer__accordion .details')].forEach(
        e => e.setAttribute('open', 'true')
    );
}

const boxDescReadMore = document.querySelector('.box.descrizione .read-more');
let isDescOpen = false;
if (boxDescReadMore) {
    boxDescReadMore.addEventListener('click', () => {
        if (isDescOpen) {
            boxDescReadMore.parentElement.querySelector('.content')
                .removeAttribute('style');
            boxDescReadMore.textContent = 'Leggi di più';
        } else {
            boxDescReadMore.parentElement.querySelector('.content')
                .style.maxHeight = '100%';
            boxDescReadMore.textContent = 'Leggi meno';
        }
        isDescOpen = !isDescOpen;
    });
}

// Subscription app ---------------------------------------------------

// (() => {
//     const _container = document.querySelectorAll('.shopify_subscriptions_app_block_label');
//     if (_container.length === 0) return;
//     const container = _container[1];
//
//     _container[0].querySelector('label').innerHTML = _container[0].querySelector('label').innerHTML
//         .replace('Acquisto una tantum', 'Acquisto singolo');
//
//     const select = document.createElement('select');
//
//     const radios = container.querySelectorAll('input[type=radio]');
//
//     const radioName = _container[0].querySelectorAll('input[type=radio]')[0].getAttribute('name');
//
//     container.querySelector('label').innerHTML = `<input id="ac-periodico" type="radio" name="${radioName}" /> Acquisto periodico`;
//
//
//
//     [
//         ...radios
//     ].forEach(
//         (radio, i) => {
//             // radio.parentElement.closest('li').style.display = 'none';
//             const option = document.createElement('option');
//             option.textContent = radio.parentElement.textContent;
//             option.value = i + '';
//             select.append(option);
//         }
//     );
//     container.append(select);
//
//     select.addEventListener('change', () => {
//         container.querySelectorAll('input[type=radio]')[parseInt(select.value)].checked = true;
//     });
// })();
